<div class="flex flex-column gap-4 w-full text-left">
	<!-- Mensaje de token inválido -->
	<ng-container *ngIf="invalidToken">
		<label class="context-label text-center w-full">
			<app-icon iconName="alert-circle" class="text-3xl text-red-500"/>
			<br />
			{{ translations['invalidLinkMessage'] }}
		</label>
		<div class="flex flex-column align-items-center pt-4 gap-4 w-full align-self-stretch">
			<app-button
				class="w-full block"
				[text]="translations['backToSignIn']"
				type="button-primary"
				(buttonClicked)="navigateToSignIn()"
			></app-button>
		</div>
	</ng-container>

	<!-- Formulario de reset -->
	<ng-container *ngIf="!invalidToken && !passwordChanged">
		<label class="context-label text-center w-full">
			{{ translations['enterNewPassword'] }}
		</label>

		<div class="flex flex-column align-items-center gap-3 align-self-stretch">
			<div class="flex flex-column align-items-start gap-2 align-self-stretch w-full">
				<app-input
					type="password"
					[label]="translations['newPassword']"
					[(ngModel)]="newPassword"
					name="newPassword"
					(ngModelChange)="onPasswordChange()"
				></app-input>

				<div class="w-full mt-1" *ngIf="newPassword">
					<div class="flex flex-column gap-1">
						<div class="requirement flex align-items-center gap-1" [class.valid]="passwordRequirements.minLength">
							<app-icon [iconName]="passwordRequirements.minLength ? 'circle-check' : 'circle-x'"></app-icon>
							{{ translations['minLength'] }}
						</div>
						<div class="requirement flex align-items-center gap-1" [class.valid]="passwordRequirements.hasUpperCase">
							<app-icon [iconName]="passwordRequirements.hasUpperCase ? 'circle-check' : 'circle-x'"></app-icon>
							{{ translations['hasUpperCase'] }}
						</div>
						<div class="requirement flex align-items-center gap-1" [class.valid]="passwordRequirements.hasLowerCase">
							<app-icon [iconName]="passwordRequirements.hasLowerCase ? 'circle-check' : 'circle-x'"></app-icon>
							{{ translations['hasLowerCase'] }}
						</div>
						<div class="requirement flex align-items-center gap-1" [class.valid]="passwordRequirements.hasNumber">
							<app-icon [iconName]="passwordRequirements.hasNumber ? 'circle-check' : 'circle-x'"></app-icon>
							{{ translations['hasNumber'] }}
						</div>
						<div class="requirement flex align-items-center gap-1" [class.valid]="passwordRequirements.hasSpecialChar">
							<app-icon [iconName]="passwordRequirements.hasSpecialChar ? 'circle-check' : 'circle-x'"></app-icon>
							{{ translations['hasSpecialChar'] }}
						</div>
					</div>
				</div>
			</div>

			<div class="flex flex-column align-items-start gap-2 align-self-stretch w-full mt-2">
				<app-input
					type="password"
					[label]="translations['confirmPassword']"
					[(ngModel)]="confirmNewPassword"
					name="confirmNewPassword"
					(ngModelChange)="onConfirmPasswordChange()"
				></app-input>
				
				<span class="error-message block mt-1" *ngIf="confirmNewPassword && !passwordsMatch">
					{{ translations['passwordsDoNotMatch'] }}
				</span>
			</div>

			<span class="error-message block mt-1" *ngIf="errorMessage">
				{{ errorMessage }}
			</span>
		</div>

		<div class="flex flex-column align-items-center pt-4 gap-4 w-full align-self-stretch">
			<app-button
				class="w-full block"
				[text]="translations['changePassword']"
				[type]="getButtonType(loading || !isPasswordValid())"
				[disabled]="loading || !isPasswordValid()"
				(buttonClicked)="onResetPassword()"
			></app-button>
		</div>
	</ng-container>

	<!-- Mensaje de éxito -->
	<ng-container *ngIf="passwordChanged">
		<label class="context-label text-center w-full">
			<app-icon iconName="circle-check" class="text-3xl text-green-500"></app-icon>
			<br />
			{{ translations['passwordChangedMessage'] }}
		</label>
		<div class="flex flex-column align-items-center pt-4 gap-4 w-full align-self-stretch">
			<app-button
				class="w-full block"
				[text]="translations['backToSignIn']"
				type="button-primary"
				(buttonClicked)="navigateToSignIn()"
			></app-button>
		</div>
	</ng-container>
</div>
